import { b as r, a as o } from "./isPrefixedCdnBase-DN8rnnom.js";
import { i as p } from "./isPrefixedCdnBase-DN8rnnom.js";
const c = async (n) => {
  const s = new TextEncoder().encode(n), t = await window.crypto.subtle.digest("SHA-256", s), e = Array.from(new Uint8Array(t)).map((a) => a.toString(16).padStart(2, "0")).join("");
  return BigInt(`0x${e}`);
}, i = 10, d = async (n) => {
  const s = await c(n);
  return r(s).slice(0, i);
}, f = async (n, s) => {
  const t = await d(n);
  return o(t, s);
};
export {
  f as getPrefixedCdnBaseAsync,
  p as isPrefixedCdnBase
};
